<template>
  <div>
    <RepeatableFormGroup
        v-model="data.images"
        label="Images"
        :errors="imageErrors"
    >
      <template v-slot:default="{ data, index, change, errors }">
        <GalleryFormGroup
            label="Image"
            :value="data.id"
            @input="change(index, 'id', $event)"
            :error="(errors.id || [])[0]"
            :company-id="companyId"
        />

        <TextFormGroup
            :value="data.text"
            name="text"
            label="Text"
            @input="change(index, 'text', $event)"
            :error="(errors.text || [])[0]"
        />
      </template>
    </RepeatableFormGroup>
  </div>
</template>

<script>
import GalleryFormGroup from "../../../../components/FormGroups/Block/Gallery"
import RepeatableFormGroup from "../../../Forms/RepeatableFormGroup.vue";
import TextFormGroup from "../../../../vendor/forms/FormGroups/Block/Text"

export default {
  components: {GalleryFormGroup,RepeatableFormGroup,TextFormGroup},

  props: {
    value: {
      required: true
    },

    errors: {
      required: true
    },

    companyId: {
      required: false,
    },
  },

  computed: {
    data: {
      get() {
        return this.value
      },

      set(value) {
        this.$emit('input', value)
      }
    },

    imageErrors() {
      return Object.entries(this.errors)
          .filter(entry => entry[0].startsWith('images.'))
          .reduce((result, entry) => ({
            ...result,
            [entry[0].substring('images.'.length)]: entry[1]
          }), {})
    }
  }
}
</script>
